import Auth from "../auth/Auth";
import { LOGOUT_URL } from "../lib/utils";

export function SSOLogout() {
  Auth.logout();
  window.location.replace(LOGOUT_URL);

  return null;
}
